import React from 'react';
import { Users, CircleCheck, Ticket } from 'lucide-react';
import SeatPieChart from './SeatPieChart';
import CategorySeats from './CategorySeats';
import { formatNumber } from '../data';

const Seats = ({ data, status }) => {
  const quota = data?.quota;
  const publicQuota = data?.publicQuota;
  return (
    <section className="bg-[#f3f2e8] py-11 min-[681px]:py-16" aria-labelledby="quota-title">
      <div className="mx-auto w-[calc(100%-40px)] min-[681px]:w-[calc(100%-56px)] min-[1001px]:w-[calc(100%-112px)] max-w-[1100px]">
        {quota && (
          <p className="mx-auto mb-8 flex w-fit items-center justify-center gap-2.5 rounded-full border border-[#b5e7bd] bg-[#f0f8eb] px-3 py-2 text-center text-[17px] font-semibold text-[#00472f] min-[681px]:px-5 min-[681px]:py-[10px] min-[681px]:text-[22px]">
            <CircleCheck size={18} aria-hidden="true" />
            {formatNumber(quota.national.total)} pèlerins pour le Bénin
          </p>
        )}
        {quota && (
          <p className="mb-[5px] text-xs uppercase tracking-[0.04em] text-[#586357]">
            Pèlerinage {quota.campaign_year}
          </p>
        )}
        <h2 id="quota-title" className="font-semibold leading-[1.3] text-inherit text-[25px] min-[681px]:text-[30px]">
          Quota du <span className="text-[#006e46]">Bénin</span>
        </h2>
        <p className="mt-3 text-base leading-[1.65] whitespace-pre-line text-left text-[#586357]">
          Aperçu de la répartition des places et de leur disponibilité
          {quota ? ` pour le pèlerinage ${quota.campaign_year}` : ''}.
        </p>
        {!quota ? (
          status
        ) : (
          <>
            <dl className="my-6 grid grid-cols-3 gap-2 min-[681px]:my-[30px] min-[681px]:gap-5">
              {[
                [CircleCheck, 'Places payées', quota.national.occupied],
                [Ticket, 'Places disponibles', quota.national.available],
                [Users, 'Quota total', quota.national.total],
              ].map(([Icon, label, value]) => (
                <div
                  key={label}
                  className="flex flex-col items-center gap-1.5 rounded-xl border border-[#dce3db] bg-white px-[5px] py-3.5 text-center min-[681px]:grid min-[681px]:grid-cols-[auto_1fr] min-[681px]:gap-x-2.5 min-[681px]:gap-y-0 min-[681px]:p-[18px] min-[681px]:text-left xl:gap-x-4 xl:p-[22px]"
                >
                  <Icon
                    className="row-span-2 size-[22px] rounded-lg bg-[#e8f4e8] p-1 text-[#4d6a37] min-[681px]:size-[34px] min-[681px]:p-[7px]"
                    aria-hidden="true"
                    size={30}
                  />
                  <dt className="text-[11px] min-[681px]:text-sm">{label}</dt>
                  <dd className="text-[23px] font-semibold leading-[1.3] text-[#00472f] min-[681px]:text-[32px]">
                    {formatNumber(value)}
                  </dd>
                </div>
              ))}
            </dl>
            <div className="grid items-center gap-6 rounded-[17px] border border-[#dce3db] bg-white px-[18px] py-6 min-[681px]:grid-cols-[0.8fr_1.5fr] min-[681px]:p-6 min-[1001px]:gap-10 min-[1001px]:px-8 min-[1001px]:py-[30px]">
              <SeatPieChart national={quota.national} />
              <CategorySeats pools={publicQuota.pools} />
            </div>
            {quota.national.total > 0 && quota.national.available === 0 && (
              <p className="mt-3 text-center text-sm font-semibold text-[#7c2d12]" role="status">
                Le quota national est entièrement occupé.
              </p>
            )}
          </>
        )}
      </div>
    </section>
  );
};
export default Seats;
